export const RISE_COLOR =  "#F23D3D";
export const FALL_COLOR =  "#30BF54";